import { GET_INFO_CARDS_START } from '../../types';

export const get_info_cards = (payload) => ({
  type: GET_INFO_CARDS_START,
  payload,
});
